import { Selection } from '@leverege/ui-redux';
import { GeoshapeAdapter } from '@leverege/ui-google-maps-elements';
import { Attributes } from '@leverege/ui-attributes';
import Util from "./Util.js";
import Model from "./GeoShapeModel.js";
const {
  getFillColor,
  getFillOpacity,
  getLineColor,
  getLineOpacity,
  getLineWidth,
  getLineStyle,
  getLabelVisible,
  getLabelColor,
  getLabelOpacity,
  getLabelSize,
  getLabelAttribute,
  getRolloverFillColor,
  getRolloverFillOpacity,
  getRolloverLineColor,
  getRolloverLineOpacity,
  getRolloverLineWidth,
  getRolloverLineStyle,
  getRolloverLabelVisible,
  getRolloverLabelColor,
  getRolloverLabelOpacity,
  getRolloverLabelSize,
  getRolloverLabelAttribute,
  getHasRolloverFillColor,
  getHasRolloverFillOpacity,
  getHasRolloverLineColor,
  getHasRolloverLineOpacity,
  getHasRolloverLineWidth,
  getHasRolloverLineStyle,
  getHasRolloverLabelVisible,
  getHasRolloverLabelColor,
  getHasRolloverLabelOpacity,
  getHasRolloverLabelSize,
  getHasRolloverLabelAttribute,
  getSelectedFillColor,
  getSelectedFillOpacity,
  getSelectedLineColor,
  getSelectedLineOpacity,
  getSelectedLineWidth,
  getSelectedLineStyle,
  getSelectedLabelVisible,
  getSelectedLabelColor,
  getSelectedLabelOpacity,
  getSelectedLabelSize,
  getSelectedLabelAttribute,
  getHasSelectedFillColor,
  getHasSelectedFillOpacity,
  getHasSelectedLineColor,
  getHasSelectedLineOpacity,
  getHasSelectedLineWidth,
  getHasSelectedLineStyle,
  getHasSelectedLabelVisible,
  getHasSelectedLabelColor,
  getHasSelectedLabelOpacity,
  getHasSelectedLabelSize,
  getHasSelectedLabelAttribute,
  getLineJoin,
  getHasSelectedLineJoin,
  getSelectedLineJoin,
  getHasRolloverLineJoin,
  getRolloverLineJoin,
  getLineCap
  // getHasSelectedSubLabelVisible, getHasSelectedSubLabelColor, getHasSelectedSubLabelOpacity, getHasSelectedSubLabelSize, getSelectedSubLabelAttribute, 
} = Model;
export default class GeoShapeAdapter extends GeoshapeAdapter {
  getShapeData(item, id, opts) {
    const options = opts || {};
    const {
      rollover,
      selected,
      mapEditing,
      model
    } = options;
    const isSelected = Selection.isSelected(selected, id);
    const isRollover = Selection.isSelected(rollover, id);
    let showLabel = null;
    let labelAttr = null;
    const isMapEditing = Selection.isSelected(mapEditing, id);
    if (isMapEditing) {
      return null;
    }
    const app = {
      visible: true,
      showLabel: true
    };
    const {
      attributeName
    } = options;
    let geoJson = Attributes.get(attributeName, item.type, item.data);
    try {
      geoJson = JSON.parse(geoJson);
    } catch (err) {
      console.warn('Failed to parse geoshape json', err);
    }
    app.showAtZoom = Model.getShowAtZoom(model);
    app.hideAtZoom = Model.getHideAtZoom(model);
    if (isSelected) {
      app.fillColor = app.fillColor == null ? getHasSelectedFillColor(model) ? Util.getColor(getSelectedFillColor(model), item) : null : app.fillColor;
      app.fillOpacity = app.fillOpacity == null ? getHasSelectedFillOpacity(model) ? Util.getNumber(getSelectedFillOpacity(model), item) : null : app.fillOpacity;
      app.lineColor = app.lineColor == null ? getHasSelectedLineColor(model) ? Util.getColor(getSelectedLineColor(model), item) : null : app.lineColor;
      app.lineWidth = app.lineWidth == null ? getHasSelectedLineWidth(model) ? Util.getNumber(getSelectedLineWidth(model), item) : null : app.lineWidth;
      app.lineOpacity = app.lineOpacity == null ? getHasSelectedLineOpacity(model) ? Util.getNumber(getSelectedLineOpacity(model), item) : null : app.lineOpacity;
      app.lineJoin = app.lineJoin == null ? getHasSelectedLineJoin(model) ? getSelectedLineJoin(model) : null : app.lineJoin;
      showLabel = rvalue(model, item, getHasSelectedLabelVisible, getSelectedLabelVisible, showLabel);
      app.labelColor = rcolor(model, item, getHasSelectedLabelColor, getSelectedLabelColor, app.labelColor);
      app.labelSize = rnumber(model, item, getHasSelectedLabelSize, getSelectedLabelSize, app.labelSize);
      app.labelOpacity = rnumber(model, item, getHasSelectedLabelOpacity, getSelectedLabelOpacity, app.labelOpacity);
      labelAttr = rvalue(model, item, getHasSelectedLabelAttribute, getSelectedLabelAttribute, labelAttr);
      if (getHasSelectedLineStyle(model)) {
        const style = getSelectedLineStyle(model);
        app.outlineStyle = style || 'default';
      }
    }
    if (isRollover) {
      app.fillColor = app.fillColor == null ? getHasRolloverFillColor(model) ? Util.getColor(getRolloverFillColor(model), item) : null : app.fillColor;
      app.fillOpacity = app.fillOpacity == null ? getHasRolloverFillOpacity(model) ? Util.getNumber(getRolloverFillOpacity(model), item) : null : app.fillOpacity;
      app.lineColor = app.lineColor == null ? getHasRolloverLineColor(model) ? Util.getColor(getRolloverLineColor(model), item) : null : app.lineColor;
      app.lineWidth = app.lineWidth == null ? getHasRolloverLineWidth(model) ? Util.getNumber(getRolloverLineWidth(model), item) : null : app.lineWidth;
      app.lineOpacity = app.lineOpacity == null ? getHasRolloverLineOpacity(model) ? Util.getNumber(getRolloverLineOpacity(model), item) : null : app.lineOpacity;
      app.lineJoin = app.lineJoin == null ? getHasRolloverLineJoin(model) ? getRolloverLineJoin(model) : null : app.lineJoin;
      showLabel = rvalue(model, item, getHasRolloverLabelVisible, getRolloverLabelVisible, null);
      app.labelColor = rcolor(model, item, getHasRolloverLabelColor, getRolloverLabelColor, null);
      app.labelSize = rnumber(model, item, getHasRolloverLabelSize, getRolloverLabelSize, null);
      app.labelOpacity = rnumber(model, item, getHasRolloverLabelOpacity, getRolloverLabelOpacity, null);
      labelAttr = rvalue(model, item, getHasRolloverLabelAttribute, getRolloverLabelAttribute, null);
      if (getHasRolloverLineStyle(model)) {
        const style = getRolloverLineStyle(model);
        app.outlineStyle = style || 'default';
      }
    }
    app.lineJoin = app.lineJoin == null ? getLineJoin(model) || 'mitre' : app.lineJoin;
    app.fillColor = app.fillColor == null ? Util.getColor(getFillColor(model), item) : app.fillColor;
    app.fillOpacity = app.fillOpacity == null ? Util.getNumber(getFillOpacity(model), item) : app.fillOpacity;
    app.lineColor = app.lineColor == null ? Util.getColor(getLineColor(model), item) : app.lineColor;
    app.lineOpacity = app.lineOpacity == null ? Util.getNumber(getLineOpacity(model), item) : app.lineOpacity;
    app.lineWidth = app.lineWidth == null ? Util.getNumber(getLineWidth(model), item) : app.lineWidth;
    app.showFill = app.fillColor != null || app.fillPattern != null;
    app.showOutline = app.lineColor != null;
    app.outlineStyle = app.outlineStyle == null ? getLineStyle(model) || 'default' : app.outlineStyle;
    showLabel = fvalue(model, item, showLabel, getLabelVisible);
    app.labelColor = fcolor(model, item, app.labelColor, getLabelColor);
    app.labelSize = fnumber(model, item, app.labelSize, getLabelSize);
    app.labelOpacity = fnumber(model, item, app.labelOpacity, getLabelOpacity);
    labelAttr = fvalue(model, item, labelAttr, getLabelAttribute);
    app.label = showLabel ? Attributes.get(labelAttr || 'name', item.type, item.data) : null;
    app.showLabel = showLabel;
    return {
      appearance: app,
      geoJson,
      dataType: item.type,
      dataRef: item.ref
    };
  }
  getLabelLayerOptions(style, layerGroup, options) {
    const {
      model,
      zoom
    } = options;
    const show = model && Model.getShowAtZoom(model);
    const hide = model && Model.getHideAtZoom(model);
    const visible = Util.getVisible(show, hide, zoom);
    return {
      visible,
      textSizeUnits: 'pixels',
      getText: d => {
        return d.properties.label;
      },
      getTextColor: d => {
        const opacity = d.properties.labelOpacity;
        return Util.getColorAndOpacity(d.properties.labelColor, opacity);
      },
      getTextSize: d => {
        return d.properties.labelSize;
      },
      textFontFamily: 'Inter, sans-serif'
    };
  }
  getFillLayerOptions(style, layerGroup, options) {
    const {
      model,
      zoom
    } = options;
    const show = model && Model.getShowAtZoom(model);
    const hide = model && Model.getHideAtZoom(model);
    const visible = Util.getVisible(show, hide, zoom);
    const lineJoin = getLineJoin(model) || 'mitre';
    const lineCap = getLineCap(model) || 'square';
    return {
      visible,
      stroked: true,
      filled: true,
      pickable: model.rolloverable || model.selectable,
      getFillColor: d => {
        const showFill = d.properties.showFill;
        const opacity = showFill ? d.properties.fillOpacity : 0;
        return Util.getColorAndOpacity(d.properties.fillColor, opacity);
      },
      lineJointRounded: lineJoin === 'round',
      lineCapRounded: lineCap === 'round',
      getLineColor: d => {
        const showOutline = d.properties.showOutline;
        const opacity = showOutline ? d.properties.lineOpacity : 0;
        return Util.getColorAndOpacity(d.properties.lineColor, opacity);
      },
      getLineWidth: d => {
        return d.properties.lineWidth || 1;
      },
      lineWidthUnits: 'pixels',
      getDashArray: d => {
        const outlineStyle = d.properties.outlineStyle;
        switch (outlineStyle) {
          case 'long-dash':
            return [8, 3];
          case 'short-dash':
            return [3, 3];
          case 'dot':
            return [1, 1];
          default:
            return null;
        }
      }
    };
  }
}
function rcolor(model, item, has, get, dValue) {
  return has(model) ? Util.getColor(get(model), item) : dValue;
}
function rnumber(model, item, has, get, dValue) {
  return has(model) ? Util.getNumber(get(model), item) : dValue;
}
function rvalue(model, item, has, get, dValue) {
  return has(model) ? get(model) : dValue;
}
function fcolor(model, item, val, get) {
  return val == null ? Util.getColor(get(model), item) : val;
}
function fnumber(model, item, val, get, dValue) {
  return val == null ? Util.getNumber(get(model), item) : val;
}
function fvalue(model, item, val, get) {
  return val == null ? get(model) : val;
}